import { eff } from "@/core/utils/effect-ts-abbr";
import { OrderDtoOld, OrderPriceDetail } from "@/shared/api-contract/api-contract";
import { Prop, Vue } from "vue-property-decorator";
import "./ref-orders.scss";

export class RefOrdersComponent extends Vue {
    @Prop({ required: true })
    orders!: readonly OrderDtoOld[];

    images(order: OrderDtoOld): readonly string[] {
        return [];
    }

    isOrderWithTBD(order: OrderDtoOld) {
        return eff.fn.pipe(
            order?.price_details || [],
            eff.array.findFirst((pd) => this.isTBD(pd)),
            eff.option.isSome,
        );
    }

    isTBD(priceDetail: OrderPriceDetail) {
        return priceDetail?.price?.toString().toUpperCase() === "TBD";
    }
}
